import script from "./qbankInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./qbankInfo.vue?vue&type=script&setup=true&lang=js"

import "./qbankInfo.vue?vue&type=style&index=0&id=0509f898&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0509f898"]])

export default __exports__